export enum EstoqueCartTypes {
  'ADD_ITEM_REQUEST' = '@estoqueCart/ADD_ITEM_REQUEST',
  'ADD_ITEM_SUCCESS' = '@estoqueCart/ADD_ITEM_SUCCESS',

  'DELETE_ITEM_REQUEST' = '@estoqueCart/DELETE_ITEM_REQUEST',
  'DELETE_ITEM_SUCCESS' = '@estoqueCart/DELETE_ITEM_SUCCESS',

  'PAGADORES_REQUEST' = '@estoqueCart/PAGADORES_REQUEST',
  'PAGADORES_SUCCESS' = '@estoqueCart/PAGADORES_SUCCESS',
  'PAGADORES_FAILURE' = '@estoqueCart/PAGADORES_FAILURE',

  'ENDERECO' = '@estoqueCart/ENDERECO',

  'CLEAR_END' = '@estoqueCart/CLEAR_END',

  'CLEAR_CART' = '@estoqueCart/CLEAR_CART',
}

export interface IPagadores {
  codParc: number;
  nome: string;
  cnpjCpf: string;
  inscricaoEstadual: string;
}

export interface IEstoqueCart {
  numNota: number;
  nuNota?: number;
  nuCobertura?: number;
  nomeParceiro?: string;
  codProduto: number;
  descricaoProduto: string;
  controle?: string;
  codPagador: number;
  codParceiro: number;
  nomePagador?: string;
  quantidade?: number;
  reservado?: number;
  pagadores?: IPagadores[];
  siglaUnidade: string;
  parceiros: number[] | any;
  cnpjCpf?: string;
  inscricaoEstadual?: string;
  endereco?: {};
  codTransportadora?: number;
  nomeTranasportadora?: string;
  clienteRetira?: boolean;
  cnpjCpfPagador: string | any;
  inscricaoPagador: string | any;
  qtdPadraoFracionado: number;
  numcontrato: number;
  dtValidade?: string;
}

export interface EstoqueCartState {
  readonly cart: IEstoqueCart[];
  readonly data: IPagadores[];
  readonly loading: boolean;
  readonly loadingLote: boolean;
  readonly error: boolean;
  readonly endereco: {};
}
